import * as Types from '../types';

export const addBlog = payload => ({
    type        : Types.ADD_BLOG,
    payload     : payload
});

export const updateBlog = payload => ({
    type        : Types.UPDATE_BLOG,
    payload     : payload
});
export const getBlog = payload => ({
    type        : Types.GET_BLOG,
    payload     : payload
});

export const getBlogDetails = payload => ({
    type        : Types.GET_BLOG_DETAILS,
    payload     : payload
});

export const clearBlogDetails = () => ({
    type        : Types.CLEAR_BLOG_DETAILS,
});

export const removeBlog = payload => ({
    type        : Types.REMOVE_BLOG,
    payload
});